// extracted by mini-css-extract-plugin
export default {"btn":"button-sebelumnya_btn__7rozL"};